/**
 * Enum for Aade Error Status Codes.
 * @readonly
 * @enum {String} AadeStatusCodeEnum
 */

const AadeStatusCodeEnum = {
  SystemError    : 'SystemError',
  XMLSyntaxError : 'XMLSyntaxError',
  TechnicalError : 'TechnicalError',
  ValidationError: 'ValidationError'
}

export default AadeStatusCodeEnum
